import React, { useState } from "react";
import "../css/contactus.scss";

function Contact() {
  const [formData, setFormData] = useState({
    companyName: "",
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    country: "Singapore",
    billingFirstName: "",
    billingLastName: "",
    billingCompany: "",
    billingAddress: "",
    billingApartment: "",
    billingPostal: "",
    billingPhone: "",
    sameAsBilling: true,
    companyTaxId: "",
    euVat: "",
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    setTimeout(() => {
      setShowSuccess(true);
      setFormData({
        companyName: "",
        firstName: "",
        lastName: "",
        email: "",
        phone: "",
        country: "Singapore",
        billingFirstName: "",
        billingLastName: "",
        billingCompany: "",
        billingAddress: "",
        billingApartment: "",
        billingPostal: "",
        billingPhone: "",
        sameAsBilling: true,
        companyTaxId: "",
        euVat: "",
      });
      setIsSubmitting(false);

      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });

      setTimeout(() => {
        setShowSuccess(false);
      }, 5000);
    }, 1000);
  };

  return (
    <div className="contact">
      <div className="contact-container">
        <h1 className="contact-title">contact us</h1>

        {showSuccess && (
          <div className="success-message">
            Thank you for your submission! We will get back to you soon.
          </div>
        )}

        <div className="contact-content">
          <div className="form-section">
            <h2 className="form-section-title">Become a Retailer</h2>
            <p className="form-section-description">
              Become a Sacuddin Partner by filling out the below form to access
              our wholesale prices
            </p>

            <form className="contact-form" onSubmit={handleSubmit}>
              <div className="form-row">
                <div className="form-group">
                  <input
                    type="text"
                    name="companyName"
                    value={formData.companyName}
                    onChange={handleInputChange}
                    placeholder="Company name"
                    className="form-input"
                  />
                </div>
              </div>

              <div className="form-row">
                <div className="form-group">
                  <input
                    type="text"
                    name="firstName"
                    value={formData.firstName}
                    onChange={handleInputChange}
                    placeholder="First name"
                    className="form-input"
                  />
                </div>
              </div>

              <div className="form-row">
                <div className="form-group">
                  <input
                    type="text"
                    name="lastName"
                    value={formData.lastName}
                    onChange={handleInputChange}
                    placeholder="Last name"
                    className="form-input"
                  />
                </div>
              </div>

              <div className="form-row">
                <div className="form-group">
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleInputChange}
                    placeholder="Email"
                    className="form-input"
                  />
                </div>
              </div>

              <div className="form-row two-columns">
                <div className="form-group">
                  <select name="countryCode" className="form-input form-select">
                    <option value="+65">🇸🇬 +65</option>
                    <option value="+1">🇺🇸 +1</option>
                    <option value="+86">🇨🇳 +86</option>
                    <option value="+44">🇬🇧 +44</option>
                    <option value="+61">🇦🇺 +61</option>
                  </select>
                </div>
                <div className="form-group">
                  <input
                    type="tel"
                    name="phone"
                    value={formData.phone}
                    onChange={handleInputChange}
                    placeholder="Phone"
                    className="form-input"
                  />
                </div>
              </div>

              <div className="billing-section">
                <h3 className="billing-title">Company billing address</h3>

                <div className="form-row">
                  <div className="form-group">
                    <select
                      name="country"
                      value={formData.country}
                      onChange={handleInputChange}
                      className="form-input form-select"
                    >
                      <option value="Singapore">Singapore</option>
                      <option value="United States">United States</option>
                      <option value="China">China</option>
                      <option value="United Kingdom">United Kingdom</option>
                      <option value="Australia">Australia</option>
                    </select>
                  </div>
                </div>

                <div className="form-row two-columns">
                  <div className="form-group">
                    <input
                      type="text"
                      name="billingFirstName"
                      value={formData.billingFirstName}
                      onChange={handleInputChange}
                      placeholder="First name"
                      className="form-input"
                    />
                  </div>
                  <div className="form-group">
                    <input
                      type="text"
                      name="billingLastName"
                      value={formData.billingLastName}
                      onChange={handleInputChange}
                      placeholder="Last name"
                      className="form-input"
                    />
                  </div>
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <input
                      type="text"
                      name="billingCompany"
                      value={formData.billingCompany}
                      onChange={handleInputChange}
                      placeholder="Company / attention"
                      className="form-input"
                    />
                  </div>
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <input
                      type="text"
                      name="billingAddress"
                      value={formData.billingAddress}
                      onChange={handleInputChange}
                      placeholder="Address"
                      className="form-input"
                    />
                  </div>
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <input
                      type="text"
                      name="billingApartment"
                      value={formData.billingApartment}
                      onChange={handleInputChange}
                      placeholder="Apartment, suite, etc"
                      className="form-input"
                    />
                  </div>
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <input
                      type="text"
                      name="billingPostal"
                      value={formData.billingPostal}
                      onChange={handleInputChange}
                      placeholder="Postal code"
                      className="form-input"
                    />
                  </div>
                </div>

                <div className="form-row two-columns">
                  <div className="form-group">
                    <select
                      name="billingCountryCode"
                      className="form-input form-select"
                    >
                      <option value="+65">🇸🇬 +65</option>
                      <option value="+1">🇺🇸 +1</option>
                      <option value="+86">🇨🇳 +86</option>
                      <option value="+44">🇬🇧 +44</option>
                      <option value="+61">🇦🇺 +61</option>
                    </select>
                  </div>
                  <div className="form-group">
                    <input
                      type="tel"
                      name="billingPhone"
                      value={formData.billingPhone}
                      onChange={handleInputChange}
                      placeholder="Phone"
                      className="form-input"
                    />
                  </div>
                </div>

                <div className="form-row">
                  <div className="form-group checkbox-group">
                    <label className="checkbox-label">
                      <input
                        type="checkbox"
                        name="sameAsBilling"
                        checked={formData.sameAsBilling}
                        onChange={handleInputChange}
                        className="form-checkbox"
                      />
                      Same as billing address
                    </label>
                  </div>
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <input
                      type="text"
                      name="companyTaxId"
                      value={formData.companyTaxId}
                      onChange={handleInputChange}
                      placeholder="Company tax ID"
                      className="form-input"
                    />
                  </div>
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <input
                      type="text"
                      name="euVat"
                      value={formData.euVat}
                      onChange={handleInputChange}
                      placeholder="EU VAT Validation"
                      className="form-input"
                    />
                  </div>
                </div>
              </div>

              <button
                type="submit"
                className="submit-button"
                disabled={isSubmitting}
              >
                {isSubmitting ? "Submitting..." : "Submit"}
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Contact;
